export default class Table {
    constructor(component) {
        this.headers = this.getHeaders()
        this.component = component;
        this.resetTable();

    }
    resetTable(empresa = null, component = null) {
        this.filtro = this.resetFiltro();
        this.sendAtt = false;
        this.firstAcess = true;
        this.buscarNotas = false;
        this.posExbPrimNota = 0;
        this.posExbUltmaNota = 0;
        this.notasPorPage = 0;
        this.qnt_total_notas = 10;
        this.pagina_atual = 1;
        this.qnt_total_paginas = 1;
        this.pagina_seguinte = 2;
        this.valor_total_notas = 0;
        this.valor_total_conta_empr = 0;
        this.valor_total_conta_nfe = 0;
        this.valor_total_conta_nfse = 0;
        this.valor_total_conta_cte = 0;
        this.valor_total_conta_colab = 0;
        this.arraySearch = []
        this.arrayNotas = []
        this.array_todas_notas = [];
        this.loading = false;
        this.nfePorPage = 0;
        this.rows_per_page_items = [10, 30, 60];
        this.pagination;
        this.arraySearch;
        this.dadosFiltrados;
        this.showSnackAtt = false;
        this.addedCustomColumn = false;
        this.selected = [];
        this.primeiro_limpo = false;
        this.busca = false;
        this.urlFiltros = '';
        this.auxHeaders = [];
        this.auxNotas = [];
        this.range = "semana";
        this.snack = { show: false, text: '', time: 5000, color: "grey darken-4", btnFColor: "red", multiple: false };
        this.rangeButtons = [
            {
                text: "7 Dias",
                value: "semana",
                width: "500px",
                noDataText: "nos últimos 7 Dias",
                selected: true,
                show: true
            },
            {
                text: "Mês Atual",
                value: "mesAtual",
                selected: false,
                noDataText: "neste Mês",
                show: true,
                width: "500px"
            },
            {
                text: "Mês anterior",
                selected: false,
                noDataText: "no Mês passado",
                value: "mesAnterior",
                show: true
            },
            {
                text: "Filtrar",
                selected: false,
                noDataText: "",
                value: "tudo",
                show: true
            },
        ]
        const nfseTomadosBH = empresa && empresa.servicos && empresa.servicos.robotizacao.find(item => item.nomeServico === 'NFSE_TOMADOS');
        if(nfseTomadosBH && component.name == "NFSE" && component.tipo === 'emitida') {
          this.rangeButtons.splice(3, 0, {
            text: "Falhas",
            value: "falhas",
            width: "500px",
            noDataText: "falhas",
            selected: true,
            show: true
          })
        }
    }
    resetFiltro() {
        this.urlFiltros = '';
        return this.filtros = {
            fechar: false,
            items: [
                { type: 'S', text: "Status", item_id: 'status', valor: null, options: ['Autorizada', 'Cancelada', 'Não Autorizada', 'Inutilizadas'], multiple: true, icon: 'local_offer' },
                { type: 'S', text: "Presença de CCe", item_id: 'cce', valor: null, options: ['Sim', 'Não'], multiple: false, icon: 'edit' },
                { type: 'S', text: "Manifestação", item_id: 'manifestacao', valor: null, options: ['Ciente', 'Confirmada', 'Não Realizada', 'Desconhecida'], multiple: true, icon: 'near_me' },
                { type: 'S', text: "Protocolada", item_id: 'protocolada', valor: null, options: ['Sim', 'Não'], multiple: false, icon: 'description' },
                { type: 'T', text: "Valor a partir", item_id: 'vlrInicial', valor: null },
                { type: 'T', text: "Valor até", item_id: 'vlrFinal', valor: null },
                // { type: 'D', text: "Data de emissão inicial", item_id: 'emissaoIni', valor: null, },
                { type: 'D', text: "Data de emissão inicial", item_id: 'emissaoIni', valor: null, data: null, index: this.menu0 },
                { type: 'D', text: "Data de emissão final", item_id: 'emissaoFim', valor: null, data: null, index: this.menu1 },
                { type: 'D', text: "Data de importação inicial", item_id: 'importacaoIni', valor: null, data: null, index: this.menu2 },
                { type: 'D', text: "Data de importação final", item_id: 'importacaoFim', valor: null, data: null, index: this.menu3 },
                { type: 'D', text: "Data de Vencimento Inicial", item_id: 'vencimentoIni', valor: null, data: null, index: this.menu4 },
                { type: 'D', text: "Data de Vencimento Final", item_id: 'vencimentoFim', valor: null, data: null, index: this.menu5 },
                { type: 'S', text: "Tipo de vencimento", item_id: 'tipoVencimento', valor: null, options: ['Parcela única', 'Parcelado', 'Não informado'], multiple: false, icon: 'date_range' },
                { type: 'L', text: "Status da Des", item_id: 'statusDes', valor: null, options: ['validado', 'pendente', 'inconsistente'], multiple: true, icon: 'local_offer' },

            ]
        };
    }
    resetAlert() {
        this.snack = { show: false, text: '', time: 3000, color: "grey darken-4", btnFColor: "red", multiple: false };
        return this.snack;
    }
    snackSuccess() {
        this.snack.color = "green darken-3";
        this.snack.btnFColor = "white";
    }
    snackDanger() {
        this.snack.color = "red darken-4";
        this.snack.btnFColor = "white";
    }
    snackAlert() {
        this.snack.color = "yellow darken-2";
        this.snack.btnFColor = "black";
    }
    snackDefault() {
        this.snack.color = "grey darken-4";
        this.snack.btnFColor = "red";
    }
    snackInfo() {
        this.snack.color = "cyan darken-3";
        this.snack.btnFColor = "white";
    }

    formatData(v) {
        if (!v) return null;
        const [year, month, day] = v.split("-");
        return `${day}/${month}/${year}`;
    }

    selecionarTodosItens(tipo) {


        switch (tipo) {
            case 'all':
                this.tradeNotaArray(
                    this.qnt_total_notas,
                    this.arrayNotas.length
                );
                if (this.selected.length == this.qnt_total_notas) {
                    this.selected = [];
                } else if (this.dadosFiltrados) {
                    this.selected = this.arraySearch.slice();
                } else {
                    this.selected = this.arrayNotas.slice();
                }
                break;
            case 'parse':
                // PEGA AS NOTAS QUE ESTÃO NA TELA
                let prmPos = this.posExbPrimNota;
                let ultPos = this.posExbUltmaNota - 1;
                ultPos = prmPos + this.pagination.rowsPerPage - 1;

                let notasEmTela = [];
                let posEncontrados = [];
                if (this.dadosFiltrados) {
                    //CASO SEJA NOTAS QUE FORAM USADAS O CAMPO DE BUSCA
                    notasEmTela = this.arraySearch.slice(prmPos, ultPos + 1);
                } else {
                    notasEmTela = this.arrayNotas.slice(prmPos, ultPos + 1);
                }
                let qntdEncontrada = 0
                var tam = this.selected.length;
                if (tam > 0) {
                    //VERIFICA SE ESSAS NOTAS JÁ CONSTAM NO ARRAY DE SELECIONADAS, CASO NÃO ADICIONAR..
                    notasEmTela.forEach(item => {
                        let itemEncontrado = false
                        this.selected.find((ele, pos) => {
                            if (ele.chave == item.chave) {
                                itemEncontrado = true;
                                posEncontrados.push(pos);
                            }
                        })
                        if (itemEncontrado) {
                            qntdEncontrada++;
                        } else {
                            this.selected.push(item);
                        }
                    })
                    if (qntdEncontrada == notasEmTela.length) {
                        notasEmTela.forEach(item => {
                            this.selected.splice(this.selected.indexOf(item), 1)
                        })
                    }
                } else {
                    this.selected = notasEmTela.slice();
                }
                break;
            case 'importador_xml':
                // PEGA AS NOTAS QUE ESTÃO NA TELA
        
                this.selected  = []
                this.primeiro_limpo = true
                break;
         
            case 'clear':
                // PEGA AS NOTAS QUE ESTÃO NA TELA
                prmPos = this.posExbPrimNota;
                ultPos = this.posExbUltmaNota - 1;
                ultPos = prmPos + this.pagination.rowsPerPage - 1;

                notasEmTela = [];
                posEncontrados = [];
                if (this.dadosFiltrados) {
                    //CASO SEJA NOTAS QUE FORAM USADAS O CAMPO DE BUSCA
                    notasEmTela = this.arraySearch.slice(prmPos, ultPos + 1);
                } else {
                    notasEmTela = this.arrayNotas.slice(prmPos, ultPos + 1);
                }
                qntdEncontrada = 0
                tam = this.selected.length;
                if (tam == 0) {
                    this.selected = []}
                break
            case 'primeiro_check':
                if (this.selected.length == 0){
                    this.selected = []
                }
                this.primeiro_limpo = true
                break;
        }
        //RETORNAR O ARRAY COM AS NOTAS SELECIONADAS
        return this.selected;
    }

    async tradeNotaArray(qntdade_notas, ultPos) {
        if (this.arrayNotas.length == this.array_todas_notas.length) {
            return;
        }
        if (this.arrayNotas.length < this.qnt_total_notas) {
            if (qntdade_notas > this.qnt_total_notas) {
                qntdade_notas = this.qnt_total_notas;
            }
            for (var i = ultPos; i < qntdade_notas; i++) {
                this.arrayNotas.push(this.array_todas_notas[i]);
            }
        }
        // this.arrayNotas.sort(function (a, b) {
        //     return a.emissao > b.emissao ? -1 : a.emissao < b.emissao ? 1 : 0;
        // });

    }

    setQntPorPage(qntNotasExibidas) {
        if (qntNotasExibidas) {
            if (
                this.arrayNotas.length == 0 &&
                this.qnt_total_notas == 999
            ) {
                this.nfePorPage = qntNotasExibidas;
            }
            if (
                qntNotasExibidas > this.arrayNotas.length &&
                qntNotasExibidas < this.qnt_total_notas
            ) {
                this.nfePorPage = qntNotasExibidas;
            }
            if (qntNotasExibidas == -1) {
                this.nfePorPage =
                    this.qnt_total_notas - this.arrayNotas.length;
            }
            if (qntNotasExibidas > this.qnt_total_notas) {
                this.nfePorPage = this.qnt_total_notas;
            }
            this.nfePorPage = qntNotasExibidas;
        } else {
            this.nfePorPage = this.rows_per_page_items[0];
        }
        return this.nfePorPage;
    }


    setPages(total_de_notas, qntNotasExibidas) {
        this.qnt_total_paginas =
            total_de_notas / qntNotasExibidas;

        if (total_de_notas % qntNotasExibidas > 0) {
            //arredondar as páginas para não ficar um valor quebrado
            this.qnt_total_paginas += 1;
            this.qnt_total_paginas = Math.floor(this.qnt_total_paginas);
        }
        return this.qnt_total_paginas;
    }


    getPosNFeExibidas(start, stop) {
        this.posExbPrimNota = start - 1;
        this.posExbUltmaNota = stop;
    }


    bufferToBase64(buf) {
        var binstr = Array.prototype.map
            .call(buf, function (ch) {
                return String.fromCharCode(ch);
            })
            .join("");
        return btoa(binstr);
    }



}





// WEBPACK FOOTER //
// ./src/domain/dataTable/Table.js